export default __webpack_public_path__ + "static/media/shoe3.9dc9bfd2.jpg";